const CredsystemColors = require('../../credsystem/themes/colors');

const colors = {
  primary: {
    20: '#FFD1EC',
    100: '#FDE6F4',
    200: '#FCD7ED',
    300: '#F9ACDA',
    400: '#F681C6',
    500: '#F033A3',
    600: '#EC008C',
    700: '#BD0070',
    800: '#8E0054',
    900: '#5E0038',
    1000: '#2F001C',
  },
  secondary: {
    100: '#F5F3F8',
    200: '#F2F0F4',
    300: '#DBDAE5',
    400: '#B5B3C8',
    500: '#8E8BAC',
    600: '#686490',
    700: '#413C73',
    800: '#1B1557',
    900: '#001433',
    1000: '#000A1A',
  },
  success: {
    100: '#DCF5E9',
    200: '#C6F5DF',
    300: '#99E1C2',
    400: '#66D1A4',
    500: '#44C790',
    600: '#00B367',
    700: '#008F52',
    800: '#006B3E',
    900: '#155747',
    1000: '#0E4235',
  },
  gray: {
    100: '#EAEAEA',
    200: '#DEDEDE',
    300: '#BBBBBB',
    400: '#717171',
    500: '#747474',
    600: '#515151',
    700: '#2E2E2E',
    800: '#1D1B1B',
    900: '#131212',
    1000: '#0A0909',
  },
  warning: {
    100: '#FFF9E6',
    200: '#FFF4CC',
    300: '#FFEBA4',
    400: '#FFDD66',
    500: '#FFD233',
    600: '#FFC700',
    700: '#BB9200',
    800: '#937300',
    900: '#665000',
    1000: '#332800',
  },
  error: {
    100: '#FFEDEE',
    200: '#FFDBDD',
    300: '#FFBFC3',
    400: '#FF939A',
    500: '#FF6F78',
    600: '#FF4B56',
    700: '#BB373F',
    800: '#932B32',
    900: '#661E22',
    1000: '#330F11',
  },
  light: {
    100: '#FFFFFF',
    200: '#D0D0D0',
    300: '#A0A0A0',
  },
  dark: {
    400: '#717171',
    500: '#414141',
    600: '#121212',
  },
  services: {
    200: '#E8D4E6',
    300: '#D1A9CD',
    400: '#BB7EB4',
    500: '#A4539B',
    600: '#8D2882',
  },
  credit: {
    200: '#FEECDD',
    300: '#FCD8BB',
    400: '#FBC599',
    500: '#F9B177',
    600: '#F89E55',
  },
  protection: {
    200: '#E7EEE6',
    300: '#D0DDCE',
    400: '#B8CDB5',
    500: '#A1BC9D',
    600: '#89AB84',
  },
  health: {
    50: '#F4F8FF',
    200: '#E6EEFB',
    300: '#CDDEF7',
    400: '#B5CDF3',
    500: '#9CBDEF',
    600: '#83ACEB',
  },
  feedback: {
    error: {
      text: '#C12218',
      main: '#FE4B58',
      bkg: '#FFDBDD',
    },
    warning: {
      text: '#907100',
      main: '#FFC634',
      bkg: '#FFF4CF',
    },
    neutral: {
      textMain: '#443F75',
      bkg: '#F2F0F4',
    },
    success: {
      text: '#155747',
      main: '#00B367',
      bkg: '#C6F5DF',
    },
  },
};

module.exports = Object.assign(colors, CredsystemColors);
